import React, { useEffect } from "react";
import { connect } from "react-redux";
import { generateAssumptions } from "../../../../store/modules/waterfall/actions";
import YearBar from "../YearBar";
import ArrayItem from "./ArrayItem";

function CashFlowSummary({
  dealType,
  assumptions,
  dispatchGenerateAssumptions,
}) {
  // Mounted
  useEffect(() => {
    dispatchGenerateAssumptions(dealType);
  }, []);

  return (
    <div>
      {assumptions && (
        <div className="pt-20">

          <YearBar data={assumptions.totalCashFlow.yearsArray} />

          <ArrayItem name="Limited Partners" data={assumptions.totalCashFlow.cashFlow.LP} />
          <ArrayItem name="Sponsor" data={assumptions.totalCashFlow.cashFlow.GP} />
          <ArrayItem name="Management" data={assumptions.totalCashFlow.cashFlow.CM} />
          <ArrayItem name="Total" data={assumptions.totalCashFlow.cashFlow.total} bold={true} />

        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  assumptions: state.waterfall.assumptions,
});

const mapDispatchToProps = (dispatch) => ({
  async dispatchGenerateAssumptions(dealType) {
    await dispatch(generateAssumptions(dealType));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CashFlowSummary);
